import React from "react";
import Ingredient from "../Ingredient";
import whole from "../../assets/images/ingredients/banana.png";
import sliced from "../../assets/images/ingredients/banana_cut.png";

const Banana = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Banana"
            image={[whole, sliced]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Banana;